import ExtensionTableDTOAbstract from "./ExtensionTableDTOAbstract";

export default class SampleExtensionTableDTO extends ExtensionTableDTOAbstract {

    ExtensionEnum = {
        Soil: {
            attribute_1: 'depth_start',
            attribute_2: 'depth_end',
            attribute_3: 'depth_total',
        },
        Septic: {
            attribute_1: 'depth_start',
            attribute_2: 'depth_end',
            attribute_3: 'depth_total',
        }
    }
    
    formatType(sample) {
        switch(sample.sample_type.name) {
            case 'Soil':
                return {
                    fields: this.formatTable(
                        sample.sample_type.name,
                        sample[`sample_${sample.sample_type.name.toLowerCase()}`]
                    )
                };
            default: 
            return [];
        }
    }
    
    static run(samples) {
        const ctx = new SampleExtensionTableDTO();
        return ctx.setExtensionTypes(samples);
    }

    static getHoverTextStatic(sample, attributeNumber) {
        const ctx = new SampleExtensionTableDTO();
        return ctx.convertToSentenceCase(ctx.getHoverText(sample.sample_type.name, attributeNumber));
    }

}